/**
 * Returns value from localStorage under key name
 * @param key - string
 * @returns any value that is stored under key name
 */
export const getItem = (key: string): any => {
  const storageValue = localStorage.getItem(key);
  if (storageValue) {
    return JSON.parse(storageValue);
  }
};

/**
 * Sets value to localStorage under key name
 * @param key - string
 * @param value - any
 */
export const setItem = (key: string, value: any): void => {
  return localStorage.setItem(key, JSON.stringify(value));
};

/**
 * Removes value from localStorage based on key
 * @param key - string
 */
export const removeItem = (key: string): void => {
  return localStorage.removeItem(key);
};
